import { createAsyncThunk } from '@reduxjs/toolkit';
import { getClientPortalPusher } from 'services/common/common.service';
import { IPusherConfig } from 'services/common/types';

export const ThunkGetClientPortalPusher = createAsyncThunk<IPusherConfig>(
  'common/getClientPortalPusher',
  () => getClientPortalPusher().then(r => r.data),
);
